const Pact = require("../../entities/Pact");
const {Age}  = require("../Constants");
const PactNames = require("../Names/PactNames");


class ScientificCooperation extends Pact {
    constructor() {
        super(
            Age.Age2,
            PactNames.ScientificCooperation,
            "Every time one of the civilizations plays a technology, it pays 2 science less and the other civilization pays 1 science.",
            {}
        )
    }
}

module.exports = ScientificCooperation;